import { EntityStatusBadgeVariant } from '@frontend/common';

export interface EntityStatusBadgeStyle {
    container: string;
    label: string;
    dot: string;
    hollowDot: boolean;
}

export const ENTITY_STATUS_BADGE_STYLES: Record<EntityStatusBadgeVariant, EntityStatusBadgeStyle> = {
    [EntityStatusBadgeVariant.Draft]: {
        container: 'border border-badge-draft-border bg-background-surface',
        label: 'text-badge-draft',
        dot: 'border border-badge-draft bg-transparent',
        hollowDot: true
    },
    [EntityStatusBadgeVariant.AwaitingDropOff]: {
        container: 'border border-transparent bg-badge-awaiting-drop-off-soft',
        label: 'text-badge-awaiting-drop-off',
        dot: 'bg-badge-awaiting-drop-off',
        hollowDot: false
    },
    [EntityStatusBadgeVariant.AwaitingPickUp]: {
        container: 'border border-transparent bg-badge-awaiting-pick-up-soft',
        label: 'text-badge-awaiting-pick-up',
        dot: 'bg-badge-awaiting-pick-up',
        hollowDot: false
    },
    [EntityStatusBadgeVariant.Completed]: {
        container: 'border border-transparent bg-badge-completed-soft',
        label: 'text-badge-completed',
        dot: 'bg-badge-completed',
        hollowDot: false
    },
    [EntityStatusBadgeVariant.Cancelled]: {
        container: 'border border-transparent bg-badge-cancelled-soft',
        label: 'text-badge-cancelled',
        dot: 'bg-badge-cancelled',
        hollowDot: false
    },
    [EntityStatusBadgeVariant.Failed]: {
        container: 'border border-transparent bg-badge-failed-soft',
        label: 'text-badge-failed',
        dot: 'bg-badge-failed',
        hollowDot: false
    }
};
